// extracted by mini-css-extract-plugin
export default {"container":"settingHeader_container__KM7og","leftArrow":"settingHeader_leftArrow__96gyi","saveButton":"settingHeader_saveButton__WO+dH"};